<template lang="pug">
  aiq-tabs(v-model="activeTab" class="campaign-tabs" type="card" @tab-click="onTabChange")
      aiq-tab-pane(:label="$t('settings_tab.campaign_tab.manage.in_progress')" name="pending")
        CustomerCampaign(:executed="false",
                         :grouped="grouped",
                         :customer="customer",
                         :CampaignList="CampaignList"
                         :CustomerList="CustomerCampaigns"
                         :allCustomerCampaigns="allCustomerCampaigns"
                         @refresh="init"
                         )
      aiq-tab-pane(:label="$t('settings_tab.campaign_tab.manage.completed')" name="completed")
        CustomerCampaign(:executed="true",
                         :customer="customer",
                         :grouped="executedGrouped",
                         :CampaignList="CampaignList"
                         :CustomerList="CustomerCampaignsExecuted"
                         @refresh="init"
                         )


</template>
<script>
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import CustomerCampaign from './CustomerCampaign.vue';

const PAGE_LIMIT = 100;
export default {
  name: 'CampaignManage',
  components: {
    CustomerCampaign,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    conversation: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    async customer() {
      await this.init();
    },
  },
  data() {
    return {
      showEditor: false,
      CampaignList: [],
      CustomerCampaigns: [],
      CustomerCampaignsExecuted: [],
      grouped: {},
      executedGrouped: {},
      activeTab: 'pending',
      allCustomerCampaigns: {},
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      const params = {
        limit: PAGE_LIMIT,
      };
      try {
        const response = await this.$store.dispatch(
          'campaign/getCampaignList',
          [params, true],
        );
        const campaignList = get(response, 'data.models', []);
        const channel = get(this.conversation, 'channel', '');

        this.CampaignList = campaignList.filter(e => e.channel === channel);

        const pendingCampaign = await this.getCustomerCampaign();
        const executedCampaign = await this.getCustomerCampaign(true);

        const { pending, executed } = this.removeExecutedFromPending(pendingCampaign, executedCampaign);

        this.CustomerCampaigns = pending;
        this.CustomerCampaignsExecuted = executed;

        this.grouped = groupBy(this.CustomerCampaigns, (item) => item.created_at);
        this.executedGrouped = groupBy(this.CustomerCampaignsExecuted, (item) => item.created_at);

        this.allCustomerCampaigns = {
          pending: this.CustomerCampaigns,
          executed: this.CustomerCampaignsExecuted,
        };
      } catch (error) {
        this.$aiq.notify.error('Error fetching campaign');
      }
    },

    removeExecutedFromPending(pendingCampaigns, executedCampaigns) {
      const pending = [...pendingCampaigns];
      const executed = [];

      executedCampaigns.forEach((item) => {
        const exist = pendingCampaigns.find((campaign) => campaign.created_at === item.created_at);
        if (exist) {
          pending.push(item);
        } else {
          executed.push(item);
        }
      });
      return { pending, executed };
    },

    async getCustomerCampaign(executed = false) {
      const customerCampaigns = await this.$store.dispatch(
        'campaign/getCustomerCampaignList',
        {
          customerId: this.customer.id,
          executed,
        },
      );
      return get(customerCampaigns, 'data.models', []);
    },

    onTabChange({paneName: key}) {
      if (this.activeTab === key) return;
      this.activeTab = key;
    },

  },
};
</script>